import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResult, PlatformMarketplaceDto, PlatformProfileDto } from '../models/platform-marketplace.dto';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  private apiUrl = `${environment.apiUrl}/api/platformhub`;

  constructor(private http: HttpClient) {}

  getPlatforms(categoryName?: string | null): Observable<ApiResult<PlatformMarketplaceDto[]>> {
    let url = `${this.apiUrl}/platforms`;
    if (categoryName) {
      url += `?categoryName=${encodeURIComponent(categoryName)}`;
    }
    return this.http.get<ApiResult<PlatformMarketplaceDto[]>>(url);
  }

  /** Get stores that are currently running promotions (active scheduled discounts). */
  getPromoStores(environment?: 'Live' | 'Test'): Observable<ApiResult<PlatformMarketplaceDto[]>> {
    let url = `${this.apiUrl}/platforms/on-promo`;
    if (environment) {
      url += `?environment=${encodeURIComponent(environment)}`;
    }
    return this.http.get<ApiResult<PlatformMarketplaceDto[]>>(url);
  }

  getPlatformProfile(platformId: string): Observable<ApiResult<PlatformProfileDto>> {
    const url = `${this.apiUrl}/platforms/${platformId}/profile`;
    return this.http.get<ApiResult<PlatformProfileDto>>(url);
  }
}